import { put, takeLatest } from "@redux-saga/core/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { call } from "redux-saga/effects";
import fetchAPI, { ApiResponse, HttpMethod } from "../../../utils/api";
import { showError, showSuccess } from "../../toaster/store/slice";
import { ResetPasswordFormValues } from "../ResetPasswordPage";
import resetPasswordPageSlice from "./slice";

type ResetPasswordResponse = ApiResponse<{ success: boolean }>;

function* resetPasswordPageSaga() {
  yield takeLatest(resetPasswordPageSlice.actions.sendRequest, handleReset);
}

function* handleReset({ payload }: PayloadAction<ResetPasswordFormValues>) {
  const response: ResetPasswordResponse = yield call(
    fetchAPI,
    `/reset-password`,
    {
      method: HttpMethod.POST,
      body: JSON.stringify(payload),
    }
  );

  if (response && response.success) {
    yield put(resetPasswordPageSlice.actions.setRequestSend());

    yield put(showSuccess("Password reset successful. Please sign in."));
  } else {
    yield put(
      showError("Something went wrong. Please try again or contact support.")
    );
  }

  yield put(resetPasswordPageSlice.actions.setIsLoading(false));
}

export default resetPasswordPageSaga;
